import { FormArray, FormBuilder, FormControl, FormControlName, FormGroup, Validators } from '@angular/forms';
import { BaseComponent } from 'src/app/framework/components/base.component';
import { ChangeDetectorRef, Component, Input, OnDestroy, OnInit, SimpleChanges } from '@angular/core';
import { ProvidersService } from '../../../providers.service';
import { MatDialog } from '@angular/material/dialog';
import { Observable } from 'rxjs';
import { DialogComponent } from 'src/app/features-common/components/dialog/dialog.component';
import Swal from 'sweetalert2';
import { FeaturesBaseComponent } from 'src/app/features-common/components/features-base.component';
import { ActivatedRoute, Params, Router } from '@angular/router';
import { disableDebugTools } from '@angular/platform-browser';
import { element } from 'protractor';
import { arrow } from '@popperjs/core';

@Component({
  selector: 'app-salesreps-update-pricelist',
  templateUrl: './salesreps-update-pricelist.component.html',
  styleUrls: ['./salesreps-update-pricelist.component.scss']
})
export class SalesrepsUpdatePricelistComponent extends BaseComponent implements OnInit, OnDestroy {
  // @Input() providers;
  @Input() productDetails;
  @Input() producttypes;
  @Input() plantypes;
  @Input() providerService;
  @Input() transactionTypes;
  @Input() carrierCountries;
  @Input() carrierTypes;
  @Input() codeGroups;
  @Input() serviceCountries;
  @Input() responseTypes;
  @Input() allProviders;
  updateProductForm: FormGroup
  providers: any;
  productId: number;
  providerId: any;
  selectedprovider;
  productstatus;
  selectedtransactionType;
  selectedproducttypes;
  selectedplantypes;
  selectedproductService;
  selectedtransactionTypes;
  selectedserviceCountry;
  selectedcarrier;
  selectedcodeGroups;
  selectedserviceCountries;
  selectedresponseTypes;
  selectedpurchaseDiscountType;
  commissionInfo: any = [];
  updatedcommissionInfo: any = [];
  //productDetails: any = [];
  selectedcurrency: any = 'USD';
  selectedstatus;
  selectedwidelyUsed;

  commisionGroup = {}
  commissions: FormArray;
  filtercommision: string;



  constructor(private fb: FormBuilder, private router: Router, public dialog: MatDialog, private providersService: ProvidersService, private actRoute: ActivatedRoute) {
    super();
    
  }



  numMask(rawValue: string): RegExp[] {
    const mask = /^(?:[0-9]+(?:\.[0-9]{0,2})?)?$/;
    const strLength = String(rawValue).length;
    const nameMask: RegExp[] = [];

    for (let i = 0; i <= strLength; i++) {
      nameMask.push(mask);
    }

    return nameMask;

  }

  ngOnChanges(changes: SimpleChanges) {

    if (changes['allProviders']) {
      this.allProviders = changes['allProviders'].currentValue;
    }

    if (changes['productDetails']) {
      //
      this.productDetails = changes['productDetails'].currentValue;
      //;
      if (this.productDetails && this.productDetails) {

        //
        this.commissionInfo = this.productDetails.commissionInfo;

        
        if (localStorage.getItem('pricelistSelected') && localStorage.getItem('pricelistSelected')) {
            this.filtercommision = localStorage.getItem('pricelistSelected');
        }
        var _filter:any = []; 
       
        this.commissionInfo.forEach( item =>{
            if(item.priceListName == this.filtercommision){
                _filter.push(item);
               
                this.commissionInfo = _filter;
                //this.filtercommision = 'Commission Plan 1 (Distributor/Sales Rep Commission)';
                let i = 0;
                this.commissions.controls = [];
                this.commissionInfo.forEach( item =>{
                  i += 1;
              // if(item.priceListName == this.filtercommision){
                  this.commisionGroup = {};
                  this.commisionGroup[item.priceListName] = new FormControl(item.priceListValue, Validators.required);

                  this.commissions.push(this.fb.group(this.commisionGroup))
                //}else{
                //  this.commissionInfo.splice(index, 1);
                //}

              });
            }
        });
        
        

        
        
       
        

        //*************************
        //  create a productData object
        // ≈***********************
        let _productDetails: any = {
          productId: this.productDetails.productdetails.productId,
          providerName: this.productDetails.providerName,
          productName: this.productDetails.productdetails.productName,
          productDescription: this.productDetails.productdetails.productDescription,
          productType: this.productDetails.productdetails.productType,
          productService: this.productDetails.productdetails.carrierService,
          responseType: this.productDetails.productdetails.responseType,
          serviceCountry: this.productDetails.productdetails.serviceCountry,
          sku: this.productDetails.productdetails.sku,
          exchangeRate: this.productDetails.productdetails.currencyRate,
          codeGroup: this.productDetails.productdetails.codeGroup,
          planType: this.productDetails.productdetails.planType,
          currency: this.productDetails.productdetails.currency,
          carrier: this.productDetails.productdetails.carrier,
          purchaseDiscountType: this.productDetails.productdetails.purchaseDiscountType,
          purchaseDiscount: this.productDetails.productdetails.purchaseDiscount,
          faceValueMinAmt: this.productDetails.productdetails.faceValueMinAmt,
          faceValueMaxAmt: this.productDetails.productdetails.faceValueMaxAmt,
          transactionType: this.productDetails.productdetails.transactionType,
          providerId: this.productDetails.productdetails.providerId,
          productStatus: this.productDetails.productdetails.productStatus,
          widelyUsed: this.productDetails.productdetails.widelyUsed,
        };

        //;
        this.productId = _productDetails.productId;

        this.selectedprovider = _productDetails.providerName;
        this.selectedproducttypes = _productDetails.productType;
        //alert(this.selectedprovider);
        this.selectedplantypes = _productDetails.planType;
        this.selectedproductService = _productDetails.productService;
        this.selectedtransactionTypes = _productDetails.transactionType;
        this.selectedserviceCountry = _productDetails.serviceCountry;
        this.selectedcarrier = _productDetails.carrier;
        this.selectedcodeGroups = _productDetails.codeGroup;
        //this.selectedserviceCountries = _productDetails.;
        this.selectedresponseTypes = _productDetails.responseType;
        this.selectedpurchaseDiscountType = _productDetails.purchaseDiscountType;
        this.selectedstatus = _productDetails.productStatus;
        this.selectedwidelyUsed = _productDetails.widelyUsed;


        // Assign values to form
        this.assignValues(_productDetails);

      }
    }

  }



  ngOnInit(): void {
    super.ngOnInit()
    this.initUpdateForm();
    this.commissions = this.updateProductForm.get('commissionInfo') as FormArray;
  }

  initUpdateForm() {
    this.updateProductForm = this.fb.group({
      providerName: [''],
      productName: [''],
      productDescription: [''],
      productType: [''],
      productService: [''],
      responseType: [''],
      serviceCountry: [''],
      sku: [''],
      exchangeRate: [''],
      codeGroup: [''],
      planType: [''],
      currency: [''],
      carrier: [''],
      purchaseDiscountType: [''],
      purchaseDiscount: [''],
      faceValueMinAmt: [''],
      faceValueMaxAmt: [''],
      transactionType: [''],
      productStatus: [''],
      widelyUsed: [''],
      commissionInfo: this.fb.array([])
    });
  }


  get f() {
    return this.updateProductForm.controls;
  }


  assignValues(_productDetails) {
    //*************************
    //  assign values to form contrls
    // ≈***********************
    this.updateProductForm.get('providerName').setValue(_productDetails.providerId);
    //this.updateProductForm.get('productId').setValue(_productDetails.productId);
    // need to push provider ID
    //providerId
    this.updateProductForm.get('productName').setValue(_productDetails.productName);
    this.updateProductForm.get('productDescription').setValue(_productDetails.productDescription);
    this.updateProductForm.get('productType').setValue(_productDetails.productType);
    this.updateProductForm.get('productService').setValue(_productDetails.productService);
    this.updateProductForm.get('responseType').setValue(_productDetails.responseType);
    this.updateProductForm.get('serviceCountry').setValue(_productDetails.serviceCountry);
    this.updateProductForm.get('sku').setValue(_productDetails.sku);
    this.updateProductForm.get('exchangeRate').setValue(_productDetails.exchangeRate);
    this.updateProductForm.get('codeGroup').setValue(_productDetails.codeGroup);
    this.updateProductForm.get('planType').setValue(_productDetails.planType);
    this.updateProductForm.get('currency').setValue(_productDetails.currency);
    this.updateProductForm.get('carrier').setValue(_productDetails.carrier);
    this.updateProductForm.get('purchaseDiscountType').setValue(_productDetails.purchaseDiscountType);
    this.updateProductForm.get('purchaseDiscount').setValue(_productDetails.purchaseDiscount);
    this.updateProductForm.get('faceValueMinAmt').setValue(_productDetails.faceValueMinAmt);
    this.updateProductForm.get('faceValueMaxAmt').setValue(_productDetails.faceValueMaxAmt);
    this.updateProductForm.get('transactionType').setValue(_productDetails.transactionType);
    this.updateProductForm.get('productStatus').setValue(_productDetails.productStatus);
    this.updateProductForm.get('widelyUsed').setValue(_productDetails.widelyUsed);

    this.providerId = _productDetails.providerId;
    this.productId = this.productId;
    // this.updateProductForm.get('commissionPlan1').setValue(_productDetails.commissionPlan1);
    // this.updateProductForm.get('commissionPlan2').setValue(_productDetails.commissionPlan2);
    // this.updateProductForm.get('commissionRate1').setValue(_productDetails.commissionRate1);
    // this.updateProductForm.get('commissionRate2').setValue(_productDetails.commissionRate2);
    //

  }


  onProductDetails() {
    if (!this.updateProductForm.valid) {
      return
    }
    //;

   

    //
    let formData: Params = {
      productId: this.productId,
      providerId: this.updateProductForm.get('providerName').value,
      productName: this.updateProductForm.get('productName').value,
      sku: this.updateProductForm.get('sku').value,
      productType: this.updateProductForm.get('productType').value,
      provider: this.allProviders.filter(e => e.providerId == this.updateProductForm.get('providerName').value)[0].providerName,
      carrier: this.updateProductForm.get('carrier').value,
      currency: this.updateProductForm.get('currency').value,
      currencyRate: this.updateProductForm.get('exchangeRate').value,
      faceValueMinAmt: this.updateProductForm.get('faceValueMinAmt').value,
      faceValueMaxAmt: this.updateProductForm.get('faceValueMaxAmt').value,
      carrierService: this.updateProductForm.get('productService').value,
      codeGroup: this.updateProductForm.get('codeGroup').value,
      planType: this.updateProductForm.get('planType').value,
      serviceCountry: this.updateProductForm.get('serviceCountry').value,
      productDescription: this.updateProductForm.get('productDescription').value,
      purchaseDiscount: this.updateProductForm.get('purchaseDiscount').value,
      purchaseDiscountType: this.updateProductForm.get('purchaseDiscountType').value,
      responseType: this.updateProductForm.get('responseType').value,
      transactionType: this.updateProductForm.get('transactionType').value,
      widelyUsed: this.updateProductForm.get('widelyUsed').value,
      productStatus:this.productDetails.productdetails.productStatus,
      fee:this.productDetails.productdetails.fee,
      productDropdownName:this.productDetails.productdetails.productDropdownName,
      carrierMappingName:this.productDetails.productdetails.carrierMappingName,
      commissionInfo: [],
      productHistory: []

    };
    let _updatedcommissionInfo: any = this.commissionInfo;
    _updatedcommissionInfo.forEach((value : any, key: any) => {
      value.priceListValue = this.updateProductForm.get('commissionInfo').value[key][value.priceListName];
      value.priceListValueType = this.updateProductForm.get('purchaseDiscountType').value;
    });
    this.updatedcommissionInfo = _updatedcommissionInfo;
   
    formData['commissionInfo'] = this.updatedcommissionInfo;
    
   
    
    this.providersService.updateProduct(formData).subscribe(
      res => {
        if (res && res.httpcode == 200) {
          if(res.responseCodes && res.responseCodes[0] == 'TILA_111'){
          Swal.fire(
            {
              title: 'Success',
              text: 'Updated Product successfully',
              icon: 'success',
              timer: 2000,
              willClose: () => {
  
              }
            }).then((result) => {
              /* Read more about handling dismissals below */
              if (result.dismiss === Swal.DismissReason.timer) {
                this.router.navigate(['features/providers/salesreps/pricelist'])
              }
            })
          }
          else if (res && res.httpcode == 400) {
            Swal.fire(
              {
                title: 'Failure',
                text: 'Updated Product Failed',
                icon: 'error',
                timer: 2000
              }
            )
          }else{
            Swal.fire(
              {
                title: res.responseStatus,
                text: res.userMessage,
                icon: 'error',
                timer: 2000,
                willClose: () => {
    
                }
              })  
          }  
        }
      }
    );
  }

  onCancel() {
    this.router.navigate(['features/providers/salesreps/pricelist'])
    //this.updateProductForm.reset()
  }

  ngOnDestroy() {
    super.ngOnDestroy()
  }
  checkSubmitDisplayed() {
    return !(this.updateProductForm.valid && !this.updateProductForm.pristine); 
  }

}
